import { AxiosInstance } from "axios";
import { User } from "../models/user";

const AUTH_API_PREFIX = "/auth";

export async function login(
	http: AxiosInstance,
	email: string,
	password: string,
	captchaToken?: string
): Promise<User> {
	const response = await http.post<User, User>(AUTH_API_PREFIX + "/sign-in", {
		email,
		password,
		captchaToken,
	});

	return response;
}

export async function googleSignIn(
	http: AxiosInstance,
	accessToken: string,
	mode: "login" | "signup",
	metaLeadEventId?: string,
	fbc?: string,
	fbp?: string,
	acceptedTerms?: boolean
): Promise<User> {
	const response = await http.post<User, User>(AUTH_API_PREFIX + "/google", {
		accessToken,
		mode,
		acceptedTerms,
		metaLeadEventId,
		fbc,
		fbp,
	});

	return response;
}

export async function signup(
	http: AxiosInstance,
	email: string,
	password: string,
	firstName: string,
	lastName: string,
	acceptedTerms: boolean,
	captchaToken?: string,
	metaLeadEventId?: string,
	fbc?: string,
	fbp?: string
): Promise<User> {
	const response = await http.post<User, User>(AUTH_API_PREFIX + "/sign-up", {
		email,
		password,
		firstName,
		lastName,
		acceptedTerms,
		captchaToken,
		metaLeadEventId,
		fbc,
		fbp,
	});

	return response;
}

export async function requestForgotPassword(
	http: AxiosInstance,
	email: string
) {
	const response = await http.post<void>(
		AUTH_API_PREFIX + "/request-forgot-password",
		{
			email,
		}
	);

	return response.data;
}

export async function confirmForgotPassword(
	http: AxiosInstance,
	email: string,
	forgotPasswordVerificationCode: string,
	password: string
) {
	const response = await http.post<void>(
		AUTH_API_PREFIX + "/confirm-forgot-password",
		{
			email,
			forgotPasswordVerificationCode,
			password,
		}
	);

	return response.data;
}

export async function changePassword(
	http: AxiosInstance,
	oldPassword: string,
	newPassword: string
): Promise<User> {
	const response = await http.post<User, User>(
		AUTH_API_PREFIX + "/change-password",
		{
			oldPassword,
			newPassword,
		}
	);

	return response;
}
